<template>
    <div>
        <el-form ref="form" :model="form" class="question-form" refs="form">
            <el-form-item v-for="(item, index) in form.list" :key="item.id">
                <div class="question-item">
                    <p class="q-i-question">
                        {{ index + 1 + '、' + item.question }}
                        <el-tooltip effect="dark" placement="right">
                            <div slot="content" style="width: 300px; font-size: 14px;">
                                {{ item.indicatorMeaning }}
                            </div>
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                        <el-switch style="margin: 0px 0 0 10px;" v-model="item.visibility" active-text="公开"
                            :disabled="switchLoading" inactive-text="不公开" @change="switchChange($event, item.id)">
                        </el-switch>
                    </p>
                    <!-- 类型1的题目 -->
                    <el-form-item v-if="item.calculationMethod === '1'" class="baseInput">
                        <!-- 1  -->
                        <el-form-item :prop="'list.' + index + '.answer'"
                            :rules="isDisable(item) === false ? { required: true, message: '不能为空', trigger: 'change' } : {}">
                            <el-select v-model="item.answer" :disabled="isDisable(item)" clearable @change="changeSaveApi">
                                <el-option v-for="item in item.calculationValue" :key="item.value" :label="item.value"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="des-input" v-show="item.answer && item.answer !== '无' && !isDisable(item)"
                            :prop="'list.' + index + '.answerExplain'"
                            :rules="item.answer && item.answer !== '无' && !isDisable(item) ? { required: true, message: '不能为空', trigger: 'blur' } : {}">
                            <el-input type="textarea" :rows="3" placeholder="请填写详细支撑信息" v-model="item.answerExplain"
                                clearable @blur="blurSaveForm"></el-input>
                        </el-form-item>
                        <el-form-item :prop="'list.' + index + '.fileList'"
                            v-show="item.answer && item.answer !== '无' && !isDisable(item)">
                            <el-table :data="item.fileList" style="width: 100%; margin-top: 5px;">
                                <el-table-column width="65" align="center">
                                    <template slot="header" slot-scope="scope">
                                        <el-button type="primary" @click="uploadTableAdd(index)">+</el-button>
                                    </template>
                                    <template slot-scope="scope">
                                        {{ scope.$index + 1 }}
                                    </template>
                                </el-table-column>
                                <el-table-column type="index" label="文件" width="500" prop="file">
                                    <template slot-scope="scope">
                                        <el-form-item style="padding-bottom: 20px;">
                                            <uploadFileMultiple @getIndex="getIndex(index, scope.$index)"
                                                @changeFilePath="changeFile" :file="item.fileList[scope.$index].file"
                                                @clearProjectFile="clearFile(scope.$index, item.fileList)"
                                                @blurSave="changeSaveApi" />
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column type="index" label="说明" width="400" align="center" prop="desp">
                                    <template slot-scope="scope">
                                        <el-form-item class="des-input"
                                            :prop="'list.' + index + '.fileList.' + scope.$index + '.desp'"
                                            :rules="{ required: true, message: '不能为空', trigger: 'blur' }"
                                            style="padding-bottom: 20px;">
                                            <el-input type="textarea" :rows="3" placeholder="请填写说明"
                                                v-model="item.fileList[scope.$index].desp" clearable
                                                @blur="blurSaveForm"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="80">
                                    <template slot-scope="scope">
                                        <el-button @click.native.prevent="uploadDeleteRow(scope.$index, item.fileList)"
                                            type="text" size="small">
                                            移除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-form-item>
                    </el-form-item>
                    <!-- 类型2的题目 -->
                    <el-form-item
                        v-if="item.calculationMethod === '2' && item.fourthIndicatorName !== '股东大会参与度' && item.fourthIndicatorName !== '董事会出席情况' && item.fourthIndicatorName !== '董事亲属关系情况'">
                        <el-form-item :prop="'list.' + index + '.answer'" :rules="isDisable(item) === false ?
                            { required: true, message: '不能为空', trigger: 'change' }
                            : {}">
                            <!-- 2 -->
                            <el-input v-model="item.answer" class="input" placeholder="请输入" :disabled="isDisable(item)"
                                clearable @blur="blurSaveForm"></el-input>
                        </el-form-item>
                        <el-form-item :prop="'list.' + index + '.fileList'"
                            v-show="item.answer !== '无' && !isDisable(item)">
                            <el-table :data="item.fileList" style="width: 100%; margin-top: 5px;">
                                <el-table-column width="65" align="center">
                                    <template slot="header" slot-scope="scope">
                                        <el-button type="primary" @click="uploadTableAdd(index)">+</el-button>
                                    </template>
                                    <template slot-scope="scope">
                                        {{ scope.$index + 1 }}
                                    </template>
                                </el-table-column>
                                <el-table-column type="index" label="文件" width="500" prop="file">
                                    <template slot-scope="scope">
                                        <el-form-item style="padding-bottom: 20px;">
                                            <uploadFileMultiple @getIndex="getIndex(index, scope.$index)"
                                                @changeFilePath="changeFile" :file="item.fileList[scope.$index].file"
                                                @clearProjectFile="clearFile(scope.$index, item.fileList)"
                                                @blurSave="changeSaveApi" />
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column type="index" label="说明" width="400" align="center" prop="desp">
                                    <template slot-scope="scope">
                                        <el-form-item class="des-input"
                                            :prop="'list.' + index + '.fileList.' + scope.$index + '.desp'"
                                            :rules="{ required: true, message: '不能为空', trigger: 'blur' }"
                                            style="padding-bottom: 20px;">
                                            <el-input type="textarea" :rows="3" placeholder="请填写说明"
                                                v-model="item.fileList[scope.$index].desp" clearable
                                                @blur="blurSaveForm"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="80">
                                    <template slot-scope="scope">
                                        <el-button @click.native.prevent="uploadDeleteRow(scope.$index, item.fileList)"
                                            type="text" size="small">
                                            移除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-form-item>
                        <el-form-item class="des-input" v-show="item.answer !== '无' && !isDisable(item)"
                            :prop="'list.' + index + '.answerExplain'"
                            :rules="item.answer !== '无' && !isDisable(item) ? { required: true, message: '不能为空', trigger: 'blur' } : {}">
                            <el-input type="textarea" :rows="3" placeholder="请填写详细支撑信息" v-model="item.answerExplain"
                                clearable @blur="blurSaveForm"></el-input>
                        </el-form-item>
                    </el-form-item>
                    <!-- 类型3的题目 -->
                    <el-form-item prop="answer" v-if="item.calculationMethod === '3'">
                        <!-- 3 -->
                        <div class="more-input">
                            <el-form-item :prop="'list.' + index + '.answer'"
                                :rules="isDisable(item) === false ? { required: true, message: '不能为空', trigger: 'change' } : {}">
                                <el-autocomplete class="input" v-model="item.answer" :fetch-suggestions="querySearch"
                                    placeholder="请输入内容" :disabled="isDisable(item)" @blur="blurSaveForm"
                                    @select="handleSelect" />
                            </el-form-item>
                            <el-form-item class="one-select" :prop="'list.' + index + '.answerFinalUnit'"
                                :rules="isDisable(item) === true || item.answer === '无' ? {} : { required: true, message: '请选择单位', trigger: 'change' }">
                                <el-select v-model="item.answerFinalUnit" placeholder="请选择单位"
                                    :disabled="item.answer === '无' || isDisable(item) === true" class="select" clearable
                                    @change="blurSaveForm">
                                    <el-option v-for="ite in item.calculationValue" :key="ite.value" :label="ite.value"
                                        :value="ite.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <el-form-item :prop="'list.' + index + '.fileList'"
                            v-show="item.answer !== '无' && !isDisable(item) && item.answer !== null">
                            <el-table :data="item.fileList" style="width: 100%; margin-top: 5px;">
                                <el-table-column width="65" align="center">
                                    <template slot="header" slot-scope="scope">
                                        <el-button type="primary" @click="uploadTableAdd(index)">+</el-button>
                                    </template>
                                    <template slot-scope="scope">
                                        {{ scope.$index + 1 }}
                                    </template>
                                </el-table-column>
                                <el-table-column type="index" label="文件" width="500" prop="file">
                                    <template slot-scope="scope">
                                        <el-form-item style="padding-bottom: 20px;">
                                            <uploadFileMultiple @getIndex="getIndex(index, scope.$index)"
                                                @changeFilePath="changeFile" :file="item.fileList[scope.$index].file"
                                                @clearProjectFile="clearFile(scope.$index, item.fileList)"
                                                @blurSave="blurSaveForm" />
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column type="index" label="说明" width="400" align="center" prop="desp">
                                    <template slot-scope="scope">
                                        <el-form-item class="des-input"
                                            :prop="'list.' + index + '.fileList.' + scope.$index + '.desp'"
                                            :rules="{ required: true, message: '不能为空', trigger: 'blur' }"
                                            style="padding-bottom: 20px;">
                                            <el-input type="textarea" :rows="3" placeholder="请填写说明"
                                                v-model="item.fileList[scope.$index].desp" clearable
                                                @blur="blurSaveForm"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="80">
                                    <template slot-scope="scope">
                                        <el-button @click.native.prevent="uploadDeleteRow(scope.$index, item.fileList)"
                                            type="text" size="small">
                                            移除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-form-item>
                        <el-form-item class="des-input"
                            v-show="item.answer !== '无' && !isDisable(item) && item.answer !== null"
                            :prop="'list.' + index + '.answerExplain'"
                            :rules="item.answer !== '无' && item.answer !== null && !isDisable(item) ? { required: true, message: '不能为空', trigger: 'change' } : {}">
                            <el-input type="textarea" placeholder="请填写详细支撑信息" :rows="3" v-model="item.answerExplain"
                                clearable @blur="blurSaveForm"></el-input>
                        </el-form-item>
                    </el-form-item>
                    <!-- 类型5的题目 -->
                    <el-form-item v-if="item.calculationMethod === '5'">
                        <el-form-item :prop="'list.' + index + '.answer'"
                            :rules="isDisable(item) === false ? { required: true, message: '不能为空', trigger: 'change' } : {}">
                            <!-- 5 -->
                            <el-cascader v-model="item.answer" :options="item.options" style="width: 354px;"
                                :rules="{ required: true, message: '请选择控股股东属性', trigger: 'change' }" clearable
                                @blur="blurSaveForm">
                            </el-cascader>
                        </el-form-item>
                        <el-form-item :prop="'list.' + index + '.fileList'"
                            v-show="item.answer && item.answer !== '无' && !isDisable(item)">
                            <el-table :data="item.fileList" style="width: 100%; margin-top: 5px;">
                                <el-table-column width="65" align="center">
                                    <template slot="header" slot-scope="scope">
                                        <el-button type="primary" @click="uploadTableAdd(index)">+</el-button>
                                    </template>
                                    <template slot-scope="scope">
                                        {{ scope.$index + 1 }}
                                    </template>
                                </el-table-column>
                                <el-table-column type="index" label="文件" width="500" prop="file">
                                    <template slot-scope="scope">
                                        <el-form-item style="padding-bottom: 20px;">
                                            <uploadFileMultiple @getIndex="getIndex(index, scope.$index)"
                                                @changeFilePath="changeFile" :file="item.fileList[scope.$index].file"
                                                @clearProjectFile="clearFile(scope.$index, item.fileList)"
                                                @blur="blurSaveForm" />
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column type="index" label="说明" width="400" align="center" prop="desp">
                                    <template slot-scope="scope">
                                        <el-form-item class="des-input"
                                            :prop="'list.' + index + '.fileList.' + scope.$index + '.desp'"
                                            :rules="{ required: true, message: '不能为空', trigger: 'blur' }"
                                            style="padding-bottom: 20px;">
                                            <el-input type="textarea" :rows="3" placeholder="请填写说明"
                                                v-model="item.fileList[scope.$index].desp" clearable
                                                @blur="blurSaveForm"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="80">
                                    <template slot-scope="scope">
                                        <el-button @click.native.prevent="uploadDeleteRow(scope.$index, item.fileList)"
                                            type="text" size="small">
                                            移除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-form-item>
                        <el-form-item class="des-input"
                            v-show="item.answer !== '' && !isDisable(item) && item.answer !== null"
                            :prop="'list.' + index + '.answerExplain'"
                            :rules="item.answer !== '无' && item.answer !== null && !isDisable(item) ? { required: true, message: '不能为空', trigger: 'change' } : {}">
                            <el-input type="textarea" placeholder="请填写详细支撑信息" :rows="3" v-model="item.answerExplain"
                                clearable @blur="blurSaveForm"></el-input>
                        </el-form-item>
                    </el-form-item>
                    <!-- 类型7的题目 -->
                    <el-form-item v-if="item.calculationMethod === '7' && item.fourthIndicatorName !== '实控人控制层级'">
                        <!-- 7 -->
                        <div class="more-input">
                            <el-form-item :prop="'list.' + index + '.answer'" :rules="isDisable(item) === false && item.answer !== '无' ? [
                                { required: true, message: '不能为空', trigger: 'change' },
                                { pattern: new RegExp(item.referRules.substr(1, item.referRules.length - 2)), message: '请填写正确的值', trigger: 'blur' }
                            ] : []" class="inner-select">
                                <el-autocomplete class="input" :value="item.answer" @input="item.answer = $event"
                                    :fetch-suggestions="querySearch" placeholder="请输入内容" :disabled="isDisable(item)"
                                    @blur="blurSaveForm" @select="handleSelect" />
                            </el-form-item>
                            <el-form-item v-show="item.calculationValue != null" class="one-select"
                                :prop="'list.' + index + '.answerFinalUnit'"
                                :rules="isDisable(item) === true || item.answer === '无' || item.calculationValue == null ? {} : { required: true, message: '请选择单位', trigger: 'change' }">
                                <el-select v-model="item.answerFinalUnit"
                                    :disabled="item.answer === '无' || isDisable(item) === true" class="select"
                                    placeholder="请选择单位" clearable @change="changeSaveApi">
                                    <el-option v-for="ite in item.calculationValue" :key="ite.value" :label="ite.value"
                                        :value="ite.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item v-show="item.dataSourceValue != null" class="two-select"
                                :prop="'list.' + index + '.answerDataSourceValue'"
                                :rules="isDisable(item) === true || item.answer === '无' || item.dataSourceValue == null ? {} : { required: true, message: '请选择口径', trigger: 'change' }">
                                <el-select v-model="item.answerDataSourceValue" placeholder="请选择口径"
                                    :disabled="item.answer === '无' || isDisable(item) === true" class="select" clearable
                                    @change="changeSaveApi">
                                    <el-option v-for="item in item.dataSourceValue" :key="item.value" :label="item.value"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <el-form-item class="des-input"
                            v-show="item.answer !== '无' && item.answer !== null && !isDisable(item)"
                            :prop="'list.' + index + '.answerExplain'"
                            :rules="item.answer !== '无' && item.answer !== null && !isDisable(item) ? { required: true, message: '不能为空', trigger: 'blur' } : {}">
                            <el-input type="textarea" :rows="3" placeholder="请填写详细支撑信息" v-model="item.answerExplain"
                                clearable @blur="blurSaveForm"></el-input>
                        </el-form-item>
                        <el-form-item :prop="'list.' + index + '.fileList'"
                            v-show="item.answer && item.answer !== '无' && !isDisable(item)">
                            <el-table :data="item.fileList" style="width: 100%; margin-top: 5px;">
                                <el-table-column width="65" align="center">
                                    <template slot="header" slot-scope="scope">
                                        <el-button type="primary" @click="uploadTableAdd(index)">+</el-button>
                                    </template>
                                    <template slot-scope="scope">
                                        {{ scope.$index + 1 }}
                                    </template>
                                </el-table-column>
                                <el-table-column type="index" label="文件" width="500" prop="file">
                                    <template slot-scope="scope">
                                        <el-form-item style="padding-bottom: 20px;">
                                            <uploadFileMultiple @getIndex="getIndex(index, scope.$index)"
                                                @changeFilePath="changeFile" :file="item.fileList[scope.$index].file"
                                                @clearProjectFile="clearFile(scope.$index, item.fileList)"
                                                @blurSave="changeSaveApi" />
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column type="index" label="说明" width="400" align="center" prop="desp">
                                    <template slot-scope="scope">
                                        <el-form-item class="des-input"
                                            :prop="'list.' + index + '.fileList.' + scope.$index + '.desp'"
                                            :rules="{ required: true, message: '不能为空', trigger: 'blur' }"
                                            style="padding-bottom: 20px;">
                                            <el-input type="textarea" :rows="3" placeholder="请填写说明"
                                                v-model="item.fileList[scope.$index].desp" clearable
                                                @blur="blurSaveForm"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="80">
                                    <template slot-scope="scope">
                                        <el-button @click.native.prevent="uploadDeleteRow(scope.$index, item.fileList)"
                                            type="text" size="small">
                                            移除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-form-item>
                    </el-form-item>
                    <!-- 类型为9的题目 -->
                    <el-form-item v-if="item.calculationMethod === '9'" :prop="'list.' + index + '.answer'"
                        :rules="{ required: true, validator: nineRules, message: '请填写数据', trigger: 'change' }">
                        <el-button type="primary" size="medium" @click="openNineDialog(item, index)"
                            :disabled="item.answer === '无'">添加</el-button>
                        <el-checkbox v-model="item.answer" style="margin-left: 10px;"
                            @change="nineControllerCheckedChange($event, item)" true-label="无"
                            false-label="有">无</el-checkbox>
                    </el-form-item>
                    <!-- 类型12的题目 -->
                    <el-form-item v-if="item.calculationMethod === '12'">
                        <el-form-item :prop="'list.' + index + '.answer'"
                            :rules="{ required: true, message: '请选择口径', trigger: 'change' }">
                            <!-- 12 -->
                            <el-select v-model="item.answer" @change="changeValue($event, item.id)" clearable>
                                <el-option v-for="item in item.calculationValue" :key="item.value" :label="item.value"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :prop="'list.' + index + '.fileList'"
                            v-show="item.answer && item.answer !== '否' && !isDisable(item)">
                            <el-table :data="item.fileList" style="width: 100%; margin-top: 5px;">
                                <el-table-column width="65" align="center">
                                    <template slot="header" slot-scope="scope">
                                        <el-button type="primary" @click="uploadTableAdd(index)">+</el-button>
                                    </template>
                                    <template slot-scope="scope">
                                        {{ scope.$index + 1 }}
                                    </template>
                                </el-table-column>
                                <!-- :prop="'list.' + index + '.fileList.' + scope.$index + '.file'"
                                            :rules="{ required: true, message: '请上传文件', trigger: 'change' }" -->
                                <el-table-column type="index" label="文件" width="500" prop="file">
                                    <template slot-scope="scope">
                                        <el-form-item style="padding-bottom: 20px;">
                                            <uploadFileMultiple @getIndex="getIndex(index, scope.$index)"
                                                @changeFilePath="changeFile" :file="item.fileList[scope.$index].file"
                                                @clearProjectFile="clearFile(scope.$index, item.fileList)"
                                                @blurSave="changeSaveApi" />
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column type="index" label="说明" width="400" align="center" prop="desp">
                                    <template slot-scope="scope">
                                        <el-form-item class="des-input"
                                            :prop="'list.' + index + '.fileList.' + scope.$index + '.desp'"
                                            :rules="{ required: true, message: '不能为空', trigger: 'blur' }"
                                            style="padding-bottom: 20px;">
                                            <el-input type="textarea" :rows="3" placeholder="请填写说明"
                                                v-model="item.fileList[scope.$index].desp" clearable
                                                @blur="blurSaveForm"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="80">
                                    <template slot-scope="scope">
                                        <el-button @click.native.prevent="uploadDeleteRow(scope.$index, item.fileList)"
                                            type="text" size="small">
                                            移除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-form-item>
                    </el-form-item>
                    <!-- 实控人控制层级 -->
                    <el-form-item v-if="item.fourthIndicatorName === '实控人控制层级'" :prop="'list.' + index + '.answer'"
                        :rules="{ required: true, message: '请输入实控人控制层级', trigger: 'change' }">
                        <el-button type="primary" size="medium" @click="actualControllerDialogVisible = true"
                            :disabled="actualControllerChecked">添加</el-button>
                        <el-checkbox v-model="actualControllerChecked" style="margin-left: 10px;"
                            @change="checked => actualControllerCheckedChange(checked, item)">无</el-checkbox>
                    </el-form-item>
                    <!-- 股东大会参与度 -->
                    <el-form-item v-if="item.fourthIndicatorName === '股东大会参与度'" :prop="'list.' + index + '.answer'"
                        :rules="{ required: true, message: '请输入股东大会参与度', trigger: 'change' }">
                        <el-button type="primary" size="medium" @click="shareholderDialogVisible = true"
                            :disabled="shareholderChecked">添加</el-button>
                        <el-checkbox v-model="shareholderChecked" style="margin-left: 10px;"
                            @change="checked => shareholderCheckedChange(checked, item)">无</el-checkbox>
                    </el-form-item>
                    <!-- 董事会出席情况 -->
                    <el-form-item v-if="item.fourthIndicatorName === '董事会出席情况'" :prop="'list.' + index + '.answer'"
                        :rules="{ required: true, message: '请输入董事会出席情况', trigger: 'change' }">
                        <el-button type="primary" size="medium" @click="directorateDialogVisible = true"
                            :disabled="directorateChecked">添加</el-button>
                        <el-checkbox v-model="directorateChecked" style="margin-left: 10px;"
                            @change="checked => directorateCheckedChange(checked, item)">无</el-checkbox>
                    </el-form-item>
                    <!-- 董事亲属关系情况 -->
                    <el-form-item v-if="item.fourthIndicatorName === '董事亲属关系情况'" :prop="'list.' + index + '.answer'"
                        :rules="{ required: true, message: '请输入董事亲属关系情况', trigger: 'change' }">
                        <el-button type="primary" size="medium" @click="kinshipDialogVisible = true"
                            :disabled="kinshipChecked">添加</el-button>
                        <el-checkbox v-model="kinshipChecked" style="margin-left: 10px;"
                            @change="checked => kinshipCheckedChange(checked, item)">无</el-checkbox>
                    </el-form-item>
                </div>
            </el-form-item>
            <el-form-item style="text-align: center;">
                <div class="footer">
                    <el-button class="bottom-btn" @click="toFirstPage">返回首页</el-button>
                    <!-- <el-button class="bottom-btn">上一页</el-button> -->
                    <el-button type="primary" @click="onSubmit('form')" class="bottom-btn submit"
                        v-show="true">提交</el-button>
                    <el-button type="primary" class="bottom-btn staging" @click="saveForm" v-show="true">暂存</el-button>
                    <!-- <el-button class="bottom-btn">下一页</el-button> -->
                </div>
            </el-form-item>
        </el-form>
        <el-dialog title="实控人控制层级" :visible.sync="actualControllerDialogVisible" width="50%" @closed="changeSaveApi">
            <el-table :data="actualControllerTableData" style="width: 100%">
                <el-table-column type="index" label="层级序号" width="80" align="center">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="控股企业">
                    <template slot-scope="scope">
                        <el-input placeholder="请输入" v-model="scope.row.name" clearable></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="shareholdingRation" label="持股比例（%）">
                    <template slot-scope="scope">
                        <el-input placeholder="请输入" v-model="scope.row.shareholdingRation" clearable></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="controlledCompany" label="被控股企业">
                    <template slot-scope="scope">
                        <el-input placeholder="请输入" v-model="scope.row.controlledCompany" clearable></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button @click.native.prevent="deleteRow(scope.$index, actualControllerTableData)" type="text"
                            size="small">
                            移除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="width: 100%; display: flex; justify-content: center; margin-top: 10px;">
                <el-button type="primary" @click="actualControllerTableAdd()">+添加一条数据</el-button>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="actualControllerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="actualControllerBindIndex()">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="股东大会参与度" :visible.sync="shareholderDialogVisible" width="60%" @closed="changeSaveApi">
            <el-select v-model="shareholderFlag" placeholder="请选择">
                <el-option key="1" label="按董事人员统计" value="1">
                </el-option>
                <el-option key="2" label="按会议次数计算" value="2">
                </el-option>
            </el-select>
            <!-- 按董事人员统计 -->
            <el-table :data="shareholderTableData" style="width: 100%" v-if="shareholderFlag == 1">
                <el-table-column prop="directorName" label="董事姓名">
                    <template slot-scope="scope">
                        <el-input @blur="shareholderDirectorNameBlur($event, scope.$index)" v-model="scope.row.directorName"
                            placeholder="请输入董事姓名" clearable></el-input>
                        <span
                            v-if="shareholderTableData[scope.$index].directorName == '' && shareholderTableData[scope.$index].directorNameState == true"
                            style="color: red">
                            请输入董事姓名
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="attendance" label="应出席股东会次数">
                    <template slot-scope="scope">
                        <el-input @blur="shareholderAttendanceBlur($event, scope.$index)" placeholder="请输入" type="number"
                            v-model.number="scope.row.attendance" :disabled="scope.row.others != ''" clearable></el-input>
                        <span
                            v-if="shareholderTableData[scope.$index].attendance == '' && shareholderTableData[scope.$index].attendanceState == true && scope.row.others == ''"
                            style="color: red">
                            请输入应出席股东会次数
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="actualAttendance" label="实际出席股东会次数">
                    <template slot-scope="scope">
                        <el-input @blur="shareholderActualAttendanceBlur($event, scope.$index)" placeholder="请输入"
                            type="number" v-model.number="scope.row.actualAttendance" :disabled="scope.row.others != ''"
                            clearable></el-input>
                        <span
                            v-if="shareholderTableData[scope.$index].actualAttendance == '' && shareholderTableData[scope.$index].actualAttendanceState == true && scope.row.others == ''"
                            style="color: red">
                            请输入实际出席股东会次数
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="others" label="其他">
                    <template slot-scope="scope">
                        <el-input @blur="shareholderOthersBlur($event, scope.$index)" placeholder="请输入"
                            v-model="scope.row.others"
                            :disabled="scope.row.attendance != '' || scope.row.actualAttendance != ''" clearable></el-input>
                        <span
                            v-if="shareholderTableData[scope.$index].others == '' && shareholderTableData[scope.$index].othersState == true && scope.row.attendance == '' && scope.row.actualAttendance == ''"
                            style="color: red">
                            请输入其他
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button @click.native.prevent="shareholderDeleteRow(scope.$index, shareholderTableData)"
                            type="text" size="small">
                            移除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 按会议次数计算 -->
            <el-table :data="shareholderTableData2" style="width: 100%" v-if="shareholderFlag == 2">
                <el-table-column prop="meetingName" label="股东会决议名称">
                    <template slot-scope="scope">
                        <el-input @blur="shareholderMeetingNameBlur($event, scope.$index)" placeholder="请输入会议名称"
                            v-model="scope.row.meetingName" clearable></el-input>
                        <span
                            v-if="shareholderTableData2[scope.$index].meetingName == '' && shareholderTableData2[scope.$index].meetingNameState == true"
                            style="color: red">
                            请输入股东会议名称
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="directorsAttend" label="应参加董事人数">
                    <template slot-scope="scope">
                        <el-input placeholder="请输入" v-model.number="scope.row.directorsAttend"
                            :disabled="scope.row.others != ''" clearable>
                        </el-input>
                        <span
                            v-if="shareholderTableData2[scope.$index].directorsAttend == '' && shareholderTableData2[scope.$index].directorsAttendState == true && scope.row.others == ''"
                            style="color: red">
                            请输入应参加董事人数
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="directorsActualAttend" label="实际出席董事人数">
                    <template slot-scope="scope">
                        <el-input placeholder="请输入" v-model.number="scope.row.directorsActualAttend"
                            :disabled="scope.row.others != ''" clearable>
                        </el-input>
                        <span
                            v-if="shareholderTableData2[scope.$index].directorsActualAttend == '' && shareholderTableData2[scope.$index].directorsActualAttendState == true && scope.row.others == ''"
                            style="color: red">
                            请输入实际出席董事人数
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="others" label="其他">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.others" placeholder="请选择"
                            :disabled="scope.row.directorsAttend != '' || scope.row.directorsActualAttend != ''" clearable>
                            <el-option key="1" label="部分参加" value="1">
                            </el-option>
                            <el-option key="2" label="全部参加" value="2">
                            </el-option>
                        </el-select>
                        <span
                            v-if="shareholderTableData2[scope.$index].others == '' && shareholderTableData2[scope.$index].othersState == true && scope.row.directorsAttend == '' && scope.row.directorsActualAttend == ''"
                            style="color: red">
                            请选择
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="originalInformation" label="原始信息">
                    <template slot-scope="scope">
                        <el-input placeholder="请输入原始信息" v-model="scope.row.originalInformation" clearable></el-input>
                        <span
                            v-if="shareholderTableData2[scope.$index].originalInformation == '' && shareholderTableData2[scope.$index].originalInformationState == true"
                            style="color: red">
                            请输入原始信息
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button @click.native.prevent="shareholderDeleteRow(scope.$index, shareholderTableData2)"
                            type="text" size="small">
                            移除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="width: 100%; display: flex; justify-content: center; margin-top: 10px;"
                v-if="shareholderFlag != ''">
                <el-button type="primary" @click="shareholderTableAdd()">+添加一条数据</el-button>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="shareholderDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="shareholderBindIndex()">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="董事会出席情况" :visible.sync="directorateDialogVisible" width="80%" @closed="changeSaveApi">
            <el-select v-model="directorateFlag" placeholder="请选择">
                <el-option key="1" label="按董事人员统计" value="1">
                </el-option>
                <el-option key="2" label="按会议次数计算" value="2">
                </el-option>
            </el-select>
            <!-- 按董事人员统计 -->
            <el-table :data="directorateTableData" style="width: 100%" v-if="directorateFlag == 1">
                <el-table-column prop="directorName" label="董事姓名">
                    <template slot-scope="scope">
                        <el-input @blur="directorateDirectorNameBlur($event, scope.$index)" v-model="scope.row.directorName"
                            placeholder="请输入董事姓名" clearable></el-input>
                        <span
                            v-if="directorateTableData[scope.$index].directorName == '' && directorateTableData[scope.$index].directorNameState == true"
                            style="color: red">
                            请输入董事姓名
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="attendance" label="应出席股东会次数">
                    <template slot-scope="scope">
                        <el-input @blur="directorateAttendanceBlur($event, scope.$index)" placeholder="请输入" type="number"
                            v-model.number="scope.row.attendance" :disabled="scope.row.others != ''" clearable></el-input>
                        <span
                            v-if="directorateTableData[scope.$index].attendance == '' && directorateTableData[scope.$index].attendanceState == true && scope.row.others == ''"
                            style="color: red">
                            请输入应出席股东会次数
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="actualAttendance" label="亲自出席股东会次数">
                    <template slot-scope="scope">
                        <el-input @blur="directorateActualAttendanceBlur($event, scope.$index)" placeholder="请输入"
                            type="number" v-model.number="scope.row.actualAttendance" :disabled="scope.row.others != ''"
                            clearable></el-input>
                        <span
                            v-if="directorateTableData[scope.$index].actualAttendance == '' && directorateTableData[scope.$index].actualAttendanceState == true && scope.row.others == ''"
                            style="color: red">
                            请输入亲自出席股东会次数
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="communicationAttendMeetings" label="通信方式参加次数">
                    <template slot-scope="scope">
                        <el-input @blur="directorateCommunicationAttendMeetingsBlur($event, scope.$index)" placeholder="请输入"
                            type="number" v-model.number="scope.row.communicationAttendMeetings"
                            :disabled="scope.row.others != ''" clearable></el-input>
                        <span
                            v-if="directorateTableData[scope.$index].communicationAttendMeetings == '' && directorateTableData[scope.$index].communicationAttendMeetingsState == true && scope.row.others == ''"
                            style="color: red">
                            请输入通信方式参加次数
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="delegateAttend" label="委托出席次数">
                    <template slot-scope="scope">
                        <el-input @blur="directorateDelegateAttendBlur($event, scope.$index)" placeholder="请输入"
                            type="number" v-model.number="scope.row.delegateAttend" :disabled="scope.row.others != ''"
                            clearable></el-input>
                        <span
                            v-if="directorateTableData[scope.$index].delegateAttend == '' && directorateTableData[scope.$index].delegateAttendState == true && scope.row.others == ''"
                            style="color: red">
                            请输入委托出席次数
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="absence" label="出席次数">
                    <template slot-scope="scope">
                        <el-input @blur="directorateAbsenceBlur($event, scope.$index)" placeholder="请输入" type="number"
                            v-model.number="scope.row.absence" :disabled="scope.row.others != ''" clearable></el-input>
                        <span
                            v-if="directorateTableData[scope.$index].absence == '' && directorateTableData[scope.$index].absenceState == true && scope.row.others == ''"
                            style="color: red">
                            请输入出席次数
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="missedTwoMeetings" label="是否连续两次未亲自参加会议">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.missedTwoMeetings"
                            @blur="directorateMissedTwoMeetingsBlur($event, scope.$index)" placeholder="请选择"
                            :disabled="scope.row.others != ''" clearable>
                            <el-option key="1" label="是" value="1">
                            </el-option>
                            <el-option key="2" label="否" value="2">
                            </el-option>
                        </el-select>
                        <span
                            v-if="directorateTableData[scope.$index].missedTwoMeetings == '' && directorateTableData[scope.$index].missedTwoMeetingsState == true && scope.row.others == ''"
                            style="color: red">
                            请输入是否连续两次未亲自参加会议
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="others" label="其他">
                    <template slot-scope="scope">
                        <el-input @blur="directorateOthersBlur($event, scope.$index)" placeholder="请输入"
                            v-model="scope.row.others" :disabled="scope.row.attendance != ''
                                || scope.row.actualAttendance != ''
                                || scope.row.communicationAttendMeetings != ''
                                || scope.row.delegateAttend != ''
                                || scope.row.absence != ''
                                || scope.row.missedTwoMeetings != ''
                                " clearable>
                        </el-input>
                        <span v-if="directorateTableData[scope.$index].others == '' &&
                            directorateTableData[scope.$index].othersState == true &&
                            scope.row.attendance == '' &&
                            scope.row.actualAttendance == ''
                            " style="color: red">
                            请输入其他
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="60">
                    <template slot-scope="scope">
                        <el-button @click.native.prevent="directorateDeleteRow(scope.$index, directorateTableData)"
                            type="text" size="small">
                            移除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 按会议次数计算 -->
            <el-table :data="directorateTableData2" style="width: 100%" v-if="directorateFlag == 2">
                <el-table-column prop="meetingName" label="股东会决议名称">
                    <template slot-scope="scope">
                        <el-input @blur="directorateMeetingNameBlur($event, scope.$index)" placeholder="请输入会议名称"
                            v-model="scope.row.meetingName" clearable></el-input>
                        <span
                            v-if="directorateTableData2[scope.$index].meetingName == '' && directorateTableData2[scope.$index].meetingNameState == true"
                            style="color: red">
                            请输入股东会议名称
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="directorsAttend" label="应参加董事人数">
                    <template slot-scope="scope">
                        <el-input @blur="directorateDirectorsAttendBlur($event, scope.$index)" placeholder="请输入"
                            v-model.number="scope.row.directorsAttend" :disabled="scope.row.others != ''" clearable>
                        </el-input>
                        <span
                            v-if="directorateTableData2[scope.$index].directorsAttend == '' && directorateTableData2[scope.$index].directorsAttendState == true && scope.row.others == ''"
                            style="color: red">
                            请输入应参加董事人数
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="directorsActualAttend" label="实际出席董事人数">
                    <template slot-scope="scope">
                        <el-input @blur="directorateDirectorsActualAttendBlur($event, scope.$index)" placeholder="请输入"
                            v-model.number="scope.row.directorsActualAttend" :disabled="scope.row.others != ''" clearable>
                        </el-input>
                        <span
                            v-if="directorateTableData2[scope.$index].directorsActualAttend == '' && directorateTableData2[scope.$index].directorsActualAttendState == true && scope.row.others == ''"
                            style="color: red">
                            请输入实际出席董事人数
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="others" label="其他">
                    <template slot-scope="scope">
                        <el-select @blur="directorateOthersBlur2($event, scope.$index)" v-model="scope.row.others"
                            placeholder="请选择"
                            :disabled="scope.row.directorsAttend != '' || scope.row.directorsActualAttend != ''" clearable>
                            <el-option key="1" label="部分参加" value="1">
                            </el-option>
                            <el-option key="2" label="全部参加" value="2">
                            </el-option>
                        </el-select>
                        <span
                            v-if="directorateTableData2[scope.$index].others == '' && directorateTableData2[scope.$index].othersState == true && scope.row.directorsAttend == '' && scope.row.directorsActualAttend == ''"
                            style="color: red">
                            请选择其他
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="originalInformation" label="原始信息">
                    <template slot-scope="scope">
                        <el-input @blur="directorateOriginalInformationBlur($event, scope.$index)" placeholder="请输入"
                            v-model="scope.row.originalInformation" clearable></el-input>
                        <span
                            v-if="directorateTableData2[scope.$index].originalInformation == '' && directorateTableData2[scope.$index].originalInformationState == true"
                            style="color: red">
                            请输入原始信息
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button @click.native.prevent="directorateDeleteRow(scope.$index, directorateTableData2)"
                            type="text" size="small">
                            移除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="width: 100%; display: flex; justify-content: center; margin-top: 10px;"
                v-if="directorateFlag != ''">
                <el-button type="primary" @click="directorateTableAdd()">+添加一条数据</el-button>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="directorateDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="directorateBindIndex()">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="董事亲属关系情况" :visible.sync="kinshipDialogVisible" width="50%" @closed="changeSaveApi">
            <el-table :data="kinshipTableData" style="width: 100%">
                <el-table-column prop="directorName" label="董事姓名">
                    <template slot-scope="scope">
                        <el-input placeholder="请输入" v-model="scope.row.directorName" clearable></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="affiliatedDirectorName" label="关联董事姓名">
                    <template slot-scope="scope">
                        <el-input placeholder="请输入" v-model="scope.row.affiliatedDirectorName" clearable></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="incidenceRelation" label="关联关系">
                    <template slot-scope="scope">
                        <el-input placeholder="请输入" v-model="scope.row.incidenceRelation" clearable></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="originalInformation" label="原始信息录入">
                    <template slot-scope="scope">
                        <el-input placeholder="请输入" v-model="scope.row.originalInformation" clearable></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button @click.native.prevent="kinshipDeleteRow(scope.$index, kinshipTableData)" type="text"
                            size="small">
                            移除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="width: 100%; display: flex; justify-content: center; margin-top: 10px;">
                <el-button type="primary" @click="kinshipTableAdd">+添加一条数据</el-button>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="kinshipDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="kinshipBindIndex">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="填写" :visible.sync="nineControllerDialogVisible" width="80%" :close-on-click-modal="false"
            @closed="dialogCloseEvent">
            <div class="dialog-select-border">
                <el-button v-for="(item, index) in dialogList" @click="changeIsShow(index)" class="dialog-select-border-btn"
                    :key="item.id" :class="{ active: item.active }">{{
                        item.fourthIndicatorName }}</el-button>
            </div>
            <el-form :model="dialogForm" ref="ruleDialogForm">
                <el-table :data="dialogForm.list" style="width: 100%; margin-bottom: 10px;">
                    <el-table-column type="index" width="40" label="序号" align="center">
                    </el-table-column>
                    <el-table-column prop="fourthIndicatorName" label="信息采集字段">
                    </el-table-column>
                    <el-table-column width="60" align="center">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" placement="top-start" v-if="scope.row.indicatorDesc">
                                <div slot="content">
                                    <p style="width: 200px;">
                                        {{ scope.row.indicatorDesc }}
                                    </p>
                                </div>
                                <!-- <img src="../../../assets/images/shi.jpg" alt="" style="width: 30px;"> -->
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column label="文件" width="500" prop="file">
                        <template slot-scope="scope">
                            <el-form-item style="padding-bottom: 20px;">
                                <uploadFileMultiple @getIndex="getNineQuestionIndex(scope.$index)"
                                    @changeFilePath="changeNineQuestionFile" :file="scope.row.popupFileList" />
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="填报数据">
                        <template slot-scope="scope">
                            <el-form-item :prop="'list.' + [scope.$index] + '.answer'"
                                :rules="[{ required: true, message: '不能为空', trigger: 'blur' }, { pattern: new RegExp(scope.row.referRules.substr(1, scope.row.referRules.length - 2)), message: '请填写正确的值', trigger: 'blur' }]">
                                <el-input v-model="dialogForm.list[scope.$index].answer" clearable></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="单位" width="230">
                        <template slot-scope="scope">
                            <el-form-item :prop="'list.' + [scope.$index] + '.answerFinalUnit'"
                                :rules="{ required: true, message: '请选择', trigger: 'change' }">
                                <el-select v-model="dialogForm.list[scope.$index].answerFinalUnit" placeholder="请选择"
                                    style="width: 200px;">
                                    <el-option v-for="item in scope.row.calculationValueList" :label="item" :key="item"
                                        :value="item"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="口径" width="230">
                        <template slot-scope="scope">
                            <el-form-item :prop="'list.' + [scope.$index] + '.answerDataSourceValue'"
                                :rules="{ required: true, message: '请选择', trigger: 'change' }">
                                <el-select v-model="dialogForm.list[scope.$index].answerDataSourceValue" placeholder="请选择"
                                    style="width: 200px;">
                                    <el-option v-for="item in scope.row.dataSourceValueList" :label="item" :key="item"
                                        :value="item"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column width="60" align="center">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" placement="top-start">
                                <div slot="content">
                                    <p style="width: 200px;">
                                        {{ scope.row.industryCase }}
                                    </p>
                                </div>
                                <!-- <img src="../../../assets/images/cna.png" alt="" style="width: 30px;"> -->
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="nineControllerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogFormSubmit('ruleDialogForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import store from '../store/index';
import { autoFormApi } from '../api/api-url/autoForm';
import {
    testPageApi
} from '../api/api-url/testPage.js'
import uploadFileMultiple from './uploadFileMultiple.vue'
import _ from 'lodash';
export default {
    props: {
        // qusList: Array,
        // name: String,
    },
    components: {
        // uploadFile,
        uploadFileMultiple,
    },
    data() {
        return {
            formIndex: 0,
            rowIndex: 0,
            form: {
                list: [],
                info: {},
            },
            infoId: '',
            name: '',
            type: '',
            page: 1,
            size: 10,
            loading: false,
            //实控人控制层级
            actualControllerTableData: [],
            actualControllerDialogVisible: false,
            actualControllerChecked: false,

            //股东大会参与度
            shareholderTableData: [],
            shareholderTableData2: [],
            shareholderDialogVisible: false,
            shareholderChecked: false,
            shareholderFlag: '',

            //董事会出席情况
            directorateTableData: [],
            directorateTableData2: [],
            directorateDialogVisible: false,
            directorateChecked: false,
            directorateFlag: '',

            //亲属关系
            kinshipTableData: [],
            kinshipDialogVisible: false,
            kinshipChecked: false,

            //类型9的题目
            nineControllerTableData: [],
            nineControllerDialogVisible: false,
            tablelistIndex: null,
            dialogList: [],
            dialogForm: {
                list: [],
            },
            dialogTitle: '',
            nineDialogFormIndex: null,
            switchLoading: false,
            restaurants: [
                {
                    "value": "无",
                }
            ],
        }
    },
    created() {
        this.infoId = this.$route.query.infoId;
        this.name = this.$route.query.name;
        this.type = this.$route.query.type;
        this.getQuestionnaireInfo()
    },
    mounted() {
    },
    // watch: {
    //     qusList(news) {
    //         this.form.list = news
    //     },
    // },
    methods: {
        //级联框递归判断
        recursionRemoveEmpty(data) {
            data = data.filter((item) => {
                if (item.children) item.children = this.recursionRemoveEmpty(item.children);
                if (item.children && item.children.length === 0) delete item.children;
                return item;
            });
            return data;
        },
        // 获取题目
        async getQuestionnaireInfo() {
            this.$emit('changeLoading', true)
            let res = await testPageApi.selectQuestionnaireInfo({
                infoId: this.infoId,
                name: this.name,
                type: this.type,
                page: this.page,
                size: this.size,
            })
            if (res) {
                let list = res.result.data
                // console.log(res.result.data);
                for (let i = 0; i < list.length; i++) {
                    // let valueList = list[i].calculationValue.split(',')
                    if (list[i].fileList === null) {
                        list[i].fileList = []
                    }
                    // list[i].planFile = []
                    // list[i].planFile.push({
                    //     name: '上传文件',
                    //     url: 'https://gb.ccx.com.cn/green/file/images/carbon_img/hgschy.png'
                    // })
                    if (list[i].parentId != null) {
                        if (list[i].answer == null) {
                            list[i].answer = '无'
                        }
                    }
                    if (list[i].calculationMethod === '9') {
                        if (list[i].othersList) {
                            let othersList = list[i].othersList
                            othersList.forEach(element => {
                                element.calculationValueList = element.calculationValue.split(',')
                                if (element.active) {
                                    list[i].answer = '有'
                                }
                            })
                        }

                    }
                    if (list[i].calculationMethod === '12') {
                        list[i].answer = '否'
                        if (localStorage.parentAnswerList) {
                            let parentList = JSON.parse(localStorage.parentAnswerList)
                            for (const j in parentList) {
                                if (parentList[j].id == list[i].id)
                                    list[i].answer = parentList[j].value
                            }
                        }
                        store.commit('setQuestionstate', {
                            id: list[i].id,
                            value: list[i].answer
                        })
                    }

                    if (list[i].dataSourceValue != null) {
                        let dataSourceValueList = list[i].dataSourceValue.split(',')
                        list[i].dataSourceValue = []

                        for (let k = 0; k < dataSourceValueList.length; k++) {
                            list[i].dataSourceValue.push({
                                value: dataSourceValueList[k]
                            })
                        }
                    }

                    if (list[i].calculationValue != null && list[i].calculationMethod === '5') {
                        let areaList = JSON.parse(list[i].calculationValue)
                        const areaList2 = this.recursionRemoveEmpty(areaList)
                        list[i].options = areaList2
                        if (list[i].answer) {
                            list[i].answer = list[i].answer.split('/')
                        }
                    } else if (list[i].calculationValue != null) {
                        let valueList = list[i].calculationValue.split(',')
                        list[i].calculationValue = []
                        for (let j = 0; j < valueList.length; j++) {
                            list[i].calculationValue.push({
                                value: valueList[j]
                            })
                        }
                    }
                    //实控人控制层级
                    if (list[i].fourthIndicatorName === '实控人控制层级' && list[i].answer != null) {
                        if (list[i].answer === '无') {
                            this.actualControllerChecked = true
                        } else {
                            let valueList = []
                            if (list[i].originalValue) {
                                valueList = JSON.parse(list[i].originalValue)
                            }
                            // this.actualControllerTableData = JSON.parse(list[i].originalValue)
                            this.actualControllerTableData = valueList
                            list[i].answer = valueList
                        }
                    }
                    //股东大会参与度
                    if (list[i].fourthIndicatorName === '股东大会参与度') {
                        if (list[i].answer === '无') {
                            this.shareholderChecked = true
                        } else {
                            let shareholderTableList = []
                            if (list[i].originalValue) {
                                shareholderTableList = JSON.parse(list[i].originalValue)
                            }
                            // const shareholderTableList = JSON.parse(list[i].originalValue)
                            if (list[i].flag == 1) {
                                this.shareholderTableData = shareholderTableList
                                this.shareholderFlag = '1'
                            } else {
                                this.shareholderFlag = '2'
                                this.shareholderTableData2 = shareholderTableList
                            }
                            list[i].answer = list[i].shareholderTableList
                        }
                    }
                    //董事会出席情况
                    if (list[i].fourthIndicatorName === '董事会出席情况') {
                        if (list[i].answer === '无') {
                            this.directorateChecked = true
                        } else {
                            let directorateTableList = []
                            if (list[i].originalValue) {
                                directorateTableList = JSON.parse(list[i].originalValue)
                            }
                            // if (!directorateTableList) directorateTableList = []
                            if (list[i].flag == 1) {
                                this.directorateTableData = directorateTableList
                                this.directorateFlag = '1'
                            } else {
                                this.directorateFlag = '2'
                                this.directorateTableData2 = directorateTableList
                            }
                            list[i].answer = list[i].directorateTableList
                        }
                    }

                    //董事亲属关系情况
                    if (list[i].fourthIndicatorName === '董事亲属关系情况') {
                        if (list[i].answer === '无') {
                            this.kinshipChecked = true
                        } else {
                            let originalValue = []
                            if (list[i].originalValue) {
                                originalValue = JSON.parse(list[i].originalValue)
                            }
                            // let originalValue = JSON.parse(list[i].originalValue)
                            // if (!originalValue) originalValue = []
                            this.kinshipTableData = originalValue
                            list[i].answer = originalValue
                        }
                    }
                }
                // console.log(list);
                this.form.list = list
                this.form.info = res.result.info
                this.$emit('changeNowInfo', res.result.info)
                this.$emit('changeLoading', false)
            }
        },
        //是否公开
        async switchChange(val, id) {
            this.switchLoading = true
            const res = await autoFormApi.visibilityApi({
                id,
                type: 2,
                status: val
            })
            if (res.code === 1) {
                this.$message.success("状态修改成功！")
                this.getQuestionnaireInfo()
            }
            this.switchLoading = false
        },
        //父级按钮改变值
        changeValue(val, id) {
            console.log(val, id);
            let obj = {
                id,
                value: val
            }
            store.commit('setQuestionstate', obj)
            this.changeSaveApi()
        },
        //根据item获取vuex中的父级状态 从而控制子级的可选状态
        isDisable(item) {
            //如果存在parentId说明存在父级
            if (item.parentId) {
                const parentList = store.state.parentAnswer  //vuex中取出父级状态数组
                let parentState = {}
                for (const i in parentList) {
                    if (parentList[i].id == item.parentId) {
                        parentState = parentList[i]   //取到父级
                    }
                }
                if (parentState.value == '否') return true  //判断父级状态，值为否则禁用输入框
            }
            return false
        },
        //输入框提示“无”
        querySearch(queryString, cb) {
            let restaurants = this.restaurants;
            let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            }
        },
        changeData() {
            // console.log(this.form.list);
            //数据处理  返回请求接口时的格式
            const list = _.cloneDeep(this.form.list)
            // console.log(list);
            list.forEach(item => {
                // if (!item.answer) {
                // console.log(item.question, item.answer);
                //     item.answer = '无'
                // }
                if (item.calculationValue != null) {
                    if (item.calculationMethod === '5') {
                        if (item.answer) {
                            typeof item.answer !== 'string' ? item.answer = item.answer.join('/') : null
                        }
                    } else {
                        let calculationValueList2 = []
                        item.calculationValue.forEach(ite => {
                            calculationValueList2.push(ite.value)
                        })
                        item.calculationValue = calculationValueList2.join(',')
                    }
                }
                if (item.dataSourceValue != null) {
                    let dataSourceValueList2 = []
                    item.dataSourceValue.forEach(ite => {
                        dataSourceValueList2.push(ite.value)
                    })
                    item.dataSourceValue = dataSourceValueList2.join(',')
                }
                if (item.fourthIndicatorName === "实控人控制层级" && item.answer) {
                    if (item.answer !== '无') {
                        item.answer = JSON.stringify(item.answer)
                    }
                }
                if (item.fourthIndicatorName === "股东大会参与度" && item.answer) {
                    if (item.answer !== '无') {
                        item.answer = JSON.stringify(item.answer)
                    }
                }
                if (item.fourthIndicatorName === "董事会出席情况" && item.answer) {
                    if (item.answer !== '无') {
                        item.answer = JSON.stringify(item.answer)
                    }
                }
                if (item.fourthIndicatorName === "董事亲属关系情况" && item.answer) {
                    if (item.answer !== '无') {
                        item.answer = JSON.stringify(item.answer)
                    }
                }

            })
            return list
        },

        //失去焦点暂存
        async blurSaveForm(e) {
            if (e.target.value && e.target.value !== '') {
                console.log(e.target.value);
                store.commit('setPageMessageList', {
                    name: this.name,
                    value: this.form.list
                })
                const list = this.changeData()
                let res = await autoFormApi.selectSaveQuestions({
                    indicatorList: list
                })
                // console.log(res)
                if (res.code === 1) {
                    // this.$message({
                    //     message: '暂存成功！',
                    //     type: 'success'
                    // });
                    // this.getQuestionnaireInfo()
                }
            }
        },
        handleSelect() {
            this.changeSaveApi()
        },
        async changeSaveApi() {
            store.commit('setPageMessageList', {
                name: this.name,
                value: this.form.list
            })
            const list = this.changeData()
            let res = await autoFormApi.selectSaveQuestions({
                indicatorList: list
            })
            // console.log(res)
            if (res.code === 1) {
                // this.$message({
                //     message: '暂存成功！',
                //     type: 'success'
                // });
                // this.getQuestionnaireInfo()
            }
        },
        //暂存
        saveForm() {
            this.$confirm('确定暂存吗？', '提示', {
                confirmButtonText: '暂存',
                cancelButtonText: '取消',
            }).then(async () => {
                store.commit('setPageMessageList', {
                    name: this.name,
                    value: this.form.list
                })
                const list = this.changeData()
                let res = await autoFormApi.selectSaveQuestions({
                    indicatorList: list
                })
                // console.log(res)
                if (res.code === 1) {
                    this.$message({
                        message: '暂存成功！',
                        type: 'success'
                    });
                    this.getQuestionnaireInfo()
                }
            }).catch()
        },
        //去首页
        //提示框
        promptBox() {
            this.$confirm('您好，您的答题尚未保存，是否保存已有答案?', '提示', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                store.commit('setPageMessageList', {
                    name: this.name,
                    value: this.form.list
                })
                const list = this.changeData()
                let res = await autoFormApi.selectSaveQuestions({
                    indicatorList: list
                })
                // console.log(res)
                if (res.code === 1) {
                    this.$message({
                        message: '暂存成功！',
                        type: 'success'
                    });
                    // this.getQuestionnaireInfo()
                }
                setTimeout(() => {
                    this.$router.push({
                        name: 'QuestionList',
                    })
                }, 200);
            }).catch((action) => {
                if (action === 'cancel') {
                    this.$router.push({
                        name: 'QuestionList',
                    })
                }
            });

        },
        toFirstPage(e) {
            // 判断是否已经暂存
            if (Object.keys(store.state.pageMessage).length === 0) {
                this.promptBox()
            } else {
                if (store.state.pageMessage[this.name]) {
                    // console.log('进来了');
                    //进行去首页 ->
                    this.$router.push({
                        name: 'QuestionList',
                    })
                } else {
                    this.promptBox()
                }

            }
            e.target.blur()

        },
        //将题目id转换为字符串格式
        questionsIdStr() {
            let list = this.form.list
            let list2 = []
            for (const i in list) {
                list2.push(list[i].id)
            }
            const str = list2.join(',')
            return str
        },
        //提交题目
        async submitQuestions() {
            const str = this.questionsIdStr()
            let res = await autoFormApi.selectSubmit({
                questionIdList: str
            })
            if (res) {
                this.$message({
                    type: 'success',
                    message: '已提交'
                });
                this.$router.push({
                    name: 'QuestionList',
                })
            }
        },
        async onSubmit(formName) {
            const list = this.changeData()
            let res = await autoFormApi.selectSaveQuestions({
                indicatorList: list
            })
            // console.log(res)
            if (res.code === 1) {
                store.commit('setPageMessageList', {
                    name: this.name,
                    value: this.form.list
                })
                this.$refs[formName].validate((valid) => {
                    //提交表单前验证表单必填项是否都填写，如果都填写，valid返回true,可以提交表单
                    if (valid) {
                        //此处编写表单验证通过的业务逻辑
                        this.$confirm('答案提交后将无法修改！确定要提交答案吗?', '提示', {
                            distinguishCancelAndClose: true,
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.submitQuestions()
                        }).catch((action) => {
                            if (action === 'cancel') {
                                this.$message({
                                    type: 'info',
                                    message: '已取消'
                                });
                            }
                        });

                    } else {
                        this.$alert('您好，您的' + this.form.info.name + '模块问题未答完，暂不能提交！', '温馨提示', {
                            confirmButtonText: '确定',
                        });
                    }
                });
            }

        },
        actualControllerCheckedChange(value, item) {
            if (value) {
                item.answer = '无'
            }
        },
        //添加实控人表格数据
        actualControllerTableAdd() {
            this.actualControllerTableData.push({
                levelNumber: '',
                name: '',
                shareholdingRation: '',
                controlledCompany: '',
            })
        },
        //删除整行
        deleteRow(index, rows) {
            console.log(rows);
            rows.splice(index, 1);
        },
        //实控人控制层级确定按钮
        actualControllerBindIndex() {
            this.actualControllerDialogVisible = false
            const list = this.actualControllerTableData
            list.forEach((item, index) => {
                item.levelNumber = index + 1
            })
            this.form.list.forEach(item => {
                if (item.fourthIndicatorName === '实控人控制层级') {
                    item.answer = this.actualControllerTableData
                }
            })
            // console.log(this.form.list);
        },

        //-------------------------------------------股东大会参与度--------------------------------------
        // 按董事人员验证数据是否符合规定
        shareholderDirectorNameBlur(e, index) {
            let value = e.target.value
            if (value == '' || value == null) {
                this.shareholderTableData[index].directorNameState = true
            } else {
                this.shareholderTableData[index].directorNameState = false
            }
        },
        shareholderAttendanceBlur(e, index) {
            let value = e.target.value
            if (value == '' || value == null) {
                this.shareholderTableData[index].attendanceState = true
            } else {
                this.shareholderTableData[index].attendanceState = false
            }
        },
        shareholderActualAttendanceBlur(e, index) {
            let value = e.target.value
            if (value == '' || value == null) {
                this.shareholderTableData[index].actualAttendanceState = true
            } else {
                this.shareholderTableData[index].actualAttendanceState = false
            }
        },
        shareholderOthersBlur(e, index) {
            let value = e.target.value
            if (value == '' || value == null) {
                this.shareholderTableData[index].othersState = true
            } else {
                this.shareholderTableData[index].othersState = false
            }
        },
        // ==================================按会议次数计算验证数据是否符合规定===================================
        shareholderMeetingNameBlur(e, index) {
            let value = e.target.value
            if (value == '' || value == null) {
                this.shareholderTableData2[index].meetingNameState = true
            } else {
                this.shareholderTableData2[index].meetingNameState = false
            }
        },

        shareholderCheckedChange(value, item) {
            if (value) {
                item.answer = '无'
            }
        },
        //添加股东大会参与度表格数据
        shareholderTableAdd() {
            if (this.shareholderFlag == 1) {
                this.shareholderTableData.push({
                    directorName: '',
                    attendance: '',
                    actualAttendance: '',
                    others: '',
                    flag: 1,
                    directorNameState: false,
                    attendanceState: false,
                    actualAttendanceState: false,
                    othersState: false,
                })
            } else {
                this.shareholderTableData2.push({
                    meetingName: '',
                    directorsAttend: '',
                    directorsActualAttend: '',
                    others: '',
                    originalInformation: '',
                    flag: 2,
                    meetingNameState: false,
                    directorsAttendState: false,
                    directorsActualAttendState: false,
                    othersState: false,
                    originalInformationState: false,
                })
            }
        },
        //删除整行
        shareholderDeleteRow(index, rows) {
            rows.splice(index, 1);
        },
        //股东大会参与度确定按钮
        shareholderBindIndex() {
            // console.log(this.shareholderTableData);
            for (const i in this.form.list) {
                if (this.form.list[i].fourthIndicatorName === '股东大会参与度') {
                    if (this.shareholderFlag == 1) {
                        if (this.shareholderTableData.length === 0) {
                            return this.$message.error('请填写完整数据！')
                        }
                        const list = this.shareholderTableData
                        for (const i in list) {
                            if (list[i].directorName == '') {
                                return this.$message.error('请填写完整数据！')
                            }
                            if (list[i].others == '') {
                                if (list[i].attendance == '' || list[i].actualAttendance == '') {
                                    return this.$message.error('请填写完整数据！')
                                }
                            }
                            if (list[i].attendance == '' || list[i].actualAttendance == '') {
                                if (list[i].others == '') {
                                    return this.$message.error('请填写完整数据！')
                                }
                            }
                            delete list[i].directorNameState
                            delete list[i].attendanceState
                            delete list[i].actualAttendanceState
                            delete list[i].othersState
                        }
                        this.form.list[i].answer = list
                        this.form.list[i].flag = 1
                        this.shareholderDialogVisible = false

                    } else {
                        if (this.shareholderTableData2.length === 0) {
                            return this.$message.error('请填写完整数据！')
                        }
                        const list = this.shareholderTableData2
                        for (const i in list) {
                            if (list[i].meetingName == '') {
                                return this.$message.error('请填写完整数据！')
                            }
                            if (list[i].others == '') {
                                if (list[i].directorsAttend == '' || list[i].directorsActualAttend == '') {
                                    return this.$message.error('请填写完整数据！')
                                }
                            }
                            if (list[i].directorsAttend == '' || list[i].directorsActualAttend == '') {
                                if (list[i].others == '') {
                                    return this.$message.error('请填写完整数据！')
                                }
                            }
                            if (list[i].originalInformation == '') {
                                return this.$message.error('请填写完整数据！')
                            }
                            delete list[i].meetingNameState
                            delete list[i].directorsAttendState
                            delete list[i].directorsActualAttendState
                            delete list[i].othersState
                            delete list[i].originalInformationState
                        }
                        this.form.list[i].answer = list
                        this.form.list[i].flag = 2
                        this.shareholderDialogVisible = false

                    }
                }
            }
            console.log(this.form.list);

        },











        //-------------------------------------------董事会出席情况--------------------------------------
        // 按董事人员验证数据是否符合规定
        //董事姓名
        directorateDirectorNameBlur(e, index) {
            let value = e.target.value
            if (value == '' || value == null) {
                this.directorateTableData[index].directorNameState = true
            } else {
                this.directorateTableData[index].directorNameState = false
            }
        },
        //应出席董事会议次数
        directorateAttendanceBlur(e, index) {
            let value = e.target.value
            if (value == '' || value == null) {
                this.directorateTableData[index].attendanceState = true
            } else {
                this.directorateTableData[index].attendanceState = false
            }
        },
        //亲自出席董事会议次数
        directorateActualAttendanceBlur(e, index) {
            let value = e.target.value
            if (value == '' || value == null) {
                this.directorateTableData[index].actualAttendanceState = true
            } else {
                this.directorateTableData[index].actualAttendanceState = false
            }
        },
        //通信方式参加慈善
        directorateCommunicationAttendMeetingsBlur(e, index) {
            let value = e.target.value
            if (value == '' || value == null) {
                this.directorateTableData[index].communicationAttendMeetingsState = true
            } else {
                this.directorateTableData[index].communicationAttendMeetingsState = false
            }
        },
        //委托出席次数
        directorateDelegateAttendBlur(e, index) {
            let value = e.target.value
            if (value == '' || value == null) {
                this.directorateTableData[index].delegateAttendState = true
            } else {
                this.directorateTableData[index].delegateAttendState = false
            }
        },
        //出席次数
        directorateAbsenceBlur(e, index) {
            let value = e.target.value
            if (value == '' || value == null) {
                this.directorateTableData[index].absenceState = true
            } else {
                this.directorateTableData[index].absenceState = false
            }
        },
        //是否连续两次未亲自参加会议
        directorateMissedTwoMeetingsBlur(e, index) {
            let value = e.target.value
            if (value == '' || value == null) {
                this.directorateTableData[index].missedTwoMeetingsState = true
            } else {
                this.directorateTableData[index].missedTwoMeetingsState = false
            }
        },
        //其他
        directorateOthersBlur(e, index) {
            let value = e.target.value
            if (value == '' || value == null) {
                this.directorateTableData[index].othersState = true
            } else {
                this.directorateTableData[index].othersState = false
            }
        },
        // ===========================按会议次数计算验证数据是否符合规定===================\
        //董事会决议名称
        directorateMeetingNameBlur(e, index) {
            let value = e.target.value
            if (value == '' || value == null) {
                this.directorateTableData2[index].meetingNameState = true
            } else {
                this.directorateTableData2[index].meetingNameState = false
            }
        },
        //应参加董事人数
        directorateDirectorsAttendBlur(e, index) {
            let value = e.target.value
            if (value == '' || value == null) {
                this.directorateTableData2[index].directorsAttendState = true
            } else {
                this.directorateTableData2[index].directorsAttendState = false
            }
        },
        //实际出席董事人数
        directorateDirectorsActualAttendBlur(e, index) {
            let value = e.target.value
            if (value == '' || value == null) {
                this.directorateTableData2[index].directorsActualAttendState = true
            } else {
                this.directorateTableData2[index].directorsActualAttendState = false
            }
        },
        //其他
        directorateOthersBlur2(e, index) {
            let value = e.target.value
            if (value == '' || value == null) {
                this.directorateTableData2[index].othersState = true
            } else {
                this.directorateTableData2[index].othersState = false
            }
        },
        //原始信息
        directorateOriginalInformationBlur(e, index) {
            let value = e.target.value
            if (value == '' || value == null) {
                this.directorateTableData2[index].originalInformationState = true
            } else {
                this.directorateTableData2[index].originalInformationState = false
            }
        },

        directorateCheckedChange(value, item) {
            if (value) {
                item.answer = '无'
            }
        },
        //添加董事会出席情况表格数据
        directorateTableAdd() {
            if (this.directorateFlag == 1) {
                this.directorateTableData.push({
                    directorName: '',
                    attendance: '',
                    actualAttendance: '',
                    communicationAttendMeetings: '',
                    delegateAttend: '',
                    absence: '',
                    missedTwoMeetings: '',
                    others: '',
                    flag: 1,
                    directorNameState: false,
                    attendanceState: false,
                    actualAttendanceState: false,
                    communicationAttendMeetingsState: false,
                    delegateAttendState: false,
                    absenceState: false,
                    missedTwoMeetingsState: false,
                    othersState: false,
                })
            } else {
                this.directorateTableData2.push({
                    meetingName: '',
                    directorsAttend: '',
                    directorsActualAttend: '',
                    others: '',
                    originalInformation: '',
                    flag: 2,
                    meetingNameState: false,
                    directorsAttendState: false,
                    directorsActualAttendState: false,
                    othersState: false,
                    originalInformationState: false,
                })
            }
        },
        //删除整行
        directorateDeleteRow(index, rows) {
            rows.splice(index, 1);
        },
        //董事会出席情况确定按钮
        directorateBindIndex() {
            // console.log(this.directorateTableData);
            for (const i in this.form.list) {
                if (this.form.list[i].fourthIndicatorName === '董事会出席情况') {
                    if (this.directorateFlag == 1) {
                        if (this.directorateTableData.length === 0) {
                            return this.$message.error('请填写完整数据！')
                        }
                        const list = this.directorateTableData
                        for (const i in list) {
                            if (list[i].directorName == '') {
                                return this.$message.error('请填写完整数据！')
                            }
                            if (list[i].others == '') {
                                if (list[i].attendance == '' || list[i].actualAttendance == '' || list[i].communicationAttendMeetings == '' || list[i].delegateAttend == '' || list[i].absence == '' || list[i].missedTwoMeetings == '') {
                                    return this.$message.error('请填写完整数据！')
                                }
                            }
                            if (list[i].attendance == '' || list[i].actualAttendance == '' || list[i].communicationAttendMeetings == '' || list[i].delegateAttend == '' || list[i].absence == '' || list[i].missedTwoMeetings == '') {
                                if (list[i].others == '') {
                                    return this.$message.error('请填写完整数据！')
                                }
                            }
                            delete list[i].directorNameState
                            delete list[i].attendanceState
                            delete list[i].actualAttendanceState
                            delete list[i].communicationAttendMeetingsState
                            delete list[i].delegateAttendState
                            delete list[i].absenceState
                            delete list[i].missedTwoMeetingsState
                            delete list[i].othersState
                        }
                        this.form.list[i].answer = list
                        this.form.list[i].flag = 1
                        this.directorateDialogVisible = false

                    } else {
                        if (this.directorateTableData2.length === 0) {
                            return this.$message.error('请填写完整数据！')
                        }
                        const list = this.directorateTableData2
                        for (const i in list) {
                            if (list[i].meetingName == '') {
                                return this.$message.error('请填写完整数据！')
                            }
                            if (list[i].others == '') {
                                if (list[i].directorsAttend == '' || list[i].directorsActualAttend == '') {
                                    return this.$message.error('请填写完整数据！')
                                }
                            }
                            if (list[i].directorsAttend == '' || list[i].directorsActualAttend == '') {
                                if (list[i].others == '') {
                                    return this.$message.error('请填写完整数据！')
                                }
                            }
                            if (list[i].originalInformation == '') {
                                return this.$message.error('请填写完整数据！')
                            }
                            delete list[i].meetingNameState
                            delete list[i].directorsAttendState
                            delete list[i].directorsActualAttendState
                            delete list[i].othersState
                            delete list[i].originalInformationState
                        }
                        this.form.list[i].answer = list
                        this.form.list[i].flag = 2
                        this.directorateDialogVisible = false

                    }
                }
            }
            console.log(this.form.list);

        },
        //---------------------------------------董事亲属关系情---------------------------------
        kinshipCheckedChange(value, item) {
            if (value) {
                item.answer = '无'
            }
        },
        //添加董事亲属关系情况表格数据
        kinshipTableAdd() {
            this.kinshipTableData.push({
                directorName: '',
                affiliatedDirectorName: '',
                incidenceRelation: '',
                originalInformation: '',
            })
        },
        //删除整行
        kinshipDeleteRow(index, rows) {
            rows.splice(index, 1);
        },
        //董事亲属关系情况确定按钮
        kinshipBindIndex() {
            this.kinshipDialogVisible = false
            // console.log(this.kinshipTableData);
            for (const i in this.form.list) {
                if (this.form.list[i].fourthIndicatorName === '董事亲属关系情况') {
                    this.form.list[i].answer = this.kinshipTableData
                }
            }
            console.log(this.form.list);
        },

        //添加上传表格数据
        uploadTableAdd(index) {
            this.form.list[index].fileList.push({
                file: [],
                desp: '',
            })
        },
        getIndex(index, scopeIndex) {
            this.formIndex = index
            this.rowIndex = scopeIndex
        },
        //删除上传整行
        uploadDeleteRow(index, list) {
            list.splice(index, 1);
            this.blurSaveForm()
        },
        //上传文件
        changeFile(val) {
            // console.log(val)
            if (val.length === 0) {
                this.form.list[this.formIndex].fileList[this.rowIndex].file = []
                return
            }
            this.form.list[this.formIndex].fileList[this.rowIndex].file = val
        },
        //清除文件
        clearFile(index, list) {
            list.splice(index, 1);
        },

        //-----------------------------------类型9的题目-----------------------------
        openNineDialog(row, index) {
            this.dialogTitle = row.fourthIndicatorName
            let list = row.othersList
            // if (row.childrenList2 && row.childrenList2.length > 0) {
            //     list = row.childrenList2
            // } else {
            //     list = row.othersList
            // }
            this.dialogList = list.map(item => {
                if (item.calculateValue) {
                    item.calculateValueList = item.calculateValue.split(',')
                } else {
                    item.calculateValueList = []
                }
                if (item.dataSourceValue) {
                    item.dataSourceValueList = item.dataSourceValue.split(',')
                } else {
                    item.dataSourceValueList = []
                }
                if (!item.popupFileList) {
                    item.popupFileList = []
                }
                // item.active = item.answer && item.answer !== '无' ? true : false
                if (item.active) {
                    this.dialogForm.list.push(item)
                }
                return item
            })
            this.tablelistIndex = index
            this.nineControllerDialogVisible = true
        },
        changeIsShow(index) {
            this.$set(this.dialogList, index, { ...this.dialogList[index], active: !this.dialogList[index].active });
            this.dialogList.forEach((item, i) => {
                if (i === index) {
                    const ind = this.dialogForm.list.findIndex(ite => ite.id === item.id)
                    if (ind === -1) {
                        this.dialogForm.list.push(item)
                    } else {
                        this.dialogForm.list.splice(ind, 1)
                    }
                }
            })
        },
        getNineQuestionIndex(index) {
            this.nineDialogFormIndex = index
        },
        changeNineQuestionFile(val) {
            this.dialogForm.list[this.nineDialogFormIndex].popupFileList = val
        },
        nineControllerCheckedChange(value, item) {
            if (value === '无') {
                item.answer = value
            } else {
                item.answer = null
                let result = item.othersList.some(ite => ite.active === true)
                if (result) {
                    return item.answer = '有'
                }
            }
        },
        dialogCloseEvent() {
            this.dialogList = []
            this.dialogForm.list = []
            this.changeSaveApi()
        },
        dialogFormSubmit(formName) {
            console.log(this.dialogForm.list);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.nineControllerDialogVisible = false
                    this.form.list[this.tablelistIndex].childrenList2 = JSON.parse(JSON.stringify(this.form.list[this.tablelistIndex].othersList))
                    this.form.list[this.tablelistIndex].childrenList2.forEach((ite, ind) => {
                        ite.originalValue = null
                        ite.originalOption = null
                        if (this.dialogForm.list.length > 0) {
                            this.form.list[this.tablelistIndex].answer = '有'
                            this.dialogForm.list.forEach(item => {
                                if (item.id === ite.id) {
                                    this.form.list[this.tablelistIndex].othersList[ind] = item
                                }
                            })
                        } else {
                            this.form.list[this.tablelistIndex].answer = null
                        }

                    })
                } else {
                    this.$message.error('请填写正确的数据！')
                }
            })
        },
        nineRules(rule, value, callback) {
            if (!value || value === '') {
                callback(new Error('请填写数据'));
            } else {
                callback();
            }
        }

    },

}
</script>

<style lang="scss">
.question-item {
    margin: 0px 60px;

    .el-form-item {
        margin: 10px 0 0 0;
    }

    .q-i-question {
        font-size: 16px;
        //font-family: PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 11px;

        .el-icon-info {
            // color: #ADB0B7;
            margin-left: 10px;
        }
    }

    .input {
        width: 354px;
    }

    .el-input__inner {
        height: 38px;
        // background: #F4F5F8;
        border-radius: 2px;
    }

    .select {
        // margin-left: 20px;
        width: 175px;
        height: 38px;
    }

    .more-input {
        margin-left: 0 !important;
        display: flex;
        justify-content: left;
        // align-items: center;
        // height: 38px;

        .input {
            width: 354px;
        }

        .el-input__inner {
            height: 38px;
            // background: #F4F5F8;
            // border-radius: 2px;
        }

        .select {
            // margin-left: 20px;
            width: 175px;
            height: 38px;
        }

        .one-select {
            margin-left: 20px;
        }

        .two-select {
            margin-left: 20px;

        }

    }

    .des-input {
        margin-top: 20px;
    }

}

.bottom-btn {
    width: 120px;
    height: 48px;
    background: #FFFFFF;
    border: 1px solid #3B9395;
    border-radius: 2px;
    color: #3B9395;
}

.submit {
    width: 229px;
    background: #3B9395;
    color: #fff
}

.staging {
    background: #3B9395;
    color: #fff
}

.footer {
    padding-top: 40px;
    padding-bottom: 102px;
}

.dialog-select-border {
    border: 1px solid #000;
    padding: 10px;
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 10px;

    .dialog-select-border-btn {
        cursor: pointer;
    }

    .active {
        background-color: #007bff;
        color: white;
    }
}
</style>